// extracted by mini-css-extract-plugin
export default {"botSelected":"WorkspaceSwitcherModal_botSelected__bWOwy","botItem":"WorkspaceSwitcherModal_botItem__qbuEu","addBotIcon":"WorkspaceSwitcherModal_addBotIcon__1lqg0"};